import React, { Component } from "react"
import PropTypes from 'prop-types'

import { Alert, Col, Container, Row } from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Redux
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"


// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation"

//import { loginUserAction } from '../../actions/authenticationActions';
import { apiError, loginUser } from "../../store/actions"

import loginImg from "../../assets/img/agent-login.png"
import "../../assets/scss/login.scss"
import Turnstile, { TURNSTILE_SITE_KEY } from "../../components/Common/Turnstile"

const FooterLogin = React.lazy(() => import("components/VerticalLayout/Footerlogin"))

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showPassword: false,
      turnstileToken: null,
    }
    this.turnstileRef = React.createRef()

    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this)
  }
   togglePassword = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }));
  };
  // handleValidSubmit
  handleValidSubmit(event, values) {
    if (TURNSTILE_SITE_KEY && !this.state.turnstileToken) {
      this.props.apiError("Please complete the security check.")
      return
    }
    this.props.loginUser(
      { ...values, turnstileToken: this.state.turnstileToken },
      this.props.history
    )
    this.turnstileRef.current?.reset()
  }

  componentDidMount() {
    this.clearLoginError()
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.location?.pathname !== this.props.location?.pathname &&
      this.props.location?.pathname === "/login"
    ) {
      this.clearLoginError()
    }
  }

  clearLoginError = () => {
    this.props.apiError("")
  }

  getErrorMessage = error => {
    if (!error) return ""
    if (typeof error === "string") return error
    const apiMessage =
      error?.response?.data?.message ||
      error?.response?.data?.Message
    if (apiMessage) return apiMessage
    if (error?.message?.includes("status code")) {
      return "Invalid User"
    }
    return error?.message || "Something went wrong"
  }


  render() {
     const { showPassword, turnstileToken } = this.state;
     const errorMessage = this.getErrorMessage(this.props.error);
     const canSubmit = !TURNSTILE_SITE_KEY || Boolean(turnstileToken);
    return (
      <React.Fragment>
         <ToastContainer autoClose={2000} />
        
         <div className="account-pages login-page">
          <Container>
            <Row className="justify-content-center align-items-center vh-100">
              <Col lg={11} xl={10}>
                <div className="login-shell-card overflow-hidden my-4">
                  <Row className="g-0 align-items-center">
                    <Col lg={6} md={6}>
                      <div className="login-form-panel">
                        <div className="login-heading">
                          <h1>Client Portal</h1>
                        </div>
                        <div className="p-2">
                          <AvForm
                            className="form-horizontal"
                            method="post"
                            onValidSubmit={this.handleValidSubmit}
                          >
                            {errorMessage ? (
                              <Alert color="danger">{errorMessage}</Alert>
                            ) : null}
                            <div className="form-group mb-3">
                              <AvField
                                name="email"
                                label="Email"
                                value=""
                                className="form-control border-r-50"
                                placeholder="Enter Email"
                                type="text"
                                required
                              />
                            </div>

                            <div className="mb-3 position-relative">
                              <AvField
                                name="password"
                                label="Password"
                                placeholder="Enter Password"
                                className="form-control border-r-50"
                                type={showPassword ? "text" : "password"}
                                required
                              />
                              <span
                                onClick={this.togglePassword}
                                style={{
                                  position: "absolute",
                                  top: "38px",
                                  right: "10px",
                                  cursor: "pointer",
                                  color: "#666",
                                }}
                              >
                                {showPassword ? <i className="far fa-eye" /> : <i className="far fa-eye-slash" />}
                              </span>
                            </div>

                            <div className="form-check mb-0">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="customControlInline"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="customControlInline"
                              >
                                Remember me
                              </label>
                            </div>

                            <Turnstile
                              ref={this.turnstileRef}
                              onVerify={token => this.setState({ turnstileToken: token })}
                            />

                            <div className="mt-3 d-grid">
                              <button
                                className="btn btn-login btn-block"
                                type="submit"
                                disabled={!canSubmit}
                              >
                                Submit
                              </button>
                            </div>

                            <div className="mt-4">
                              <Link to="/forgot-password" className="login-forgot-link">
                                <i className="mdi mdi-lock me-1" /> Forgot your
                                password?
                              </Link>
                            </div>
                          </AvForm>
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} md={6} className="d-none d-md-block">
                      <div className="login-art-panel">
                        <img
                          src={loginImg}
                          className="img-fluid login-art-img"
                          alt="Client login"
                          decoding="async"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
          <React.Suspense fallback={null}>
            <FooterLogin />
          </React.Suspense>
        </div>
      </React.Fragment>
    )
  }
}

Login.propTypes = {
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  location: PropTypes.object,
  loginUser: PropTypes.func,
}

const mapStateToProps = state => {
  const { error } = state.Login
  return { error }
}

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError })(Login)
)
